<template>
	<div>
		<table class="w-100">
			<thead>
				<tr class="headers">
					<th
						v-for="(col, indexCol) in columns"
						:key="indexCol"
					>{{col.title}}</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(row, indexRow) in rowsComputed"
					:key="indexRow"
				>
					<slot :row="row"></slot>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>

function rowsComputed() {
	return this.rows.filter(r => r.value !== 'actions');
}

function columnsComputed() {
	return this.columns.filter(c => c.value !== 'actions');
}

export default {
	name: 'table-standar',
	computed: {
		columnsComputed,
		rowsComputed,
	},
	props: {
		columns: {
			default: () => [],
			type: Array,
		},
		rows: {
			default: () => [],
			type: Array,
		},
	},
};
</script>
<style lang="scss" scoped>
	.headers {
		background-color: color(border-grey);

		th {
			padding: 0.5rem 0;
		}
	}
	table {
		border-collapse: collapse;

		tbody {
			tr {
				td {
					border-bottom: 0.1rem solid color(border-grey);
    				box-sizing: content-box;
					height: 8rem;
					padding: 1.5rem 1rem;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// tableStd.vue?b69f9d2c